<template>
  <template v-for="(tag, index) in tags" :key="tag">
    <a-tooltip v-if="tag.length > 20" :title="tag">
      <a-tag :class="'tag-color-' + index % 5" :closable="true" @close="handleTagRemove(tag)">
        {{ `${tag.slice(0, 20)}...` }}
      </a-tag>
    </a-tooltip>
    <a-tag v-else :class="'tag-color-' + index % 5" :closable="true" @close="handleTagRemove(tag)">
      {{ tag }}
    </a-tag>
  </template>

  <a-input
    v-if="tagInputVisible"
    ref="tagInputRef"
    type="text"
    size="small"
    :style="{ width: '78px' }"
    v-model:value="tagInputValue"
    @blur="handleTagInputConfirm"
    @keyup.enter="handleTagInputConfirm"
  />
  <a-tag v-else @click="showTagInput" style="background: #fff; border-style: dashed">
    <plus-outlined />
    New Tag
  </a-tag>
</template>

<script setup>
import {defineEmits, defineProps, ref, watch, nextTick} from 'vue';
import {PlusOutlined} from "@ant-design/icons-vue";

const emit = defineEmits(['update:tags']);
const props = defineProps({
  tags: Array,
});

const tagInputRef = ref();

// eslint-disable-next-line
const tags = ref([]);
const tagInputVisible = ref(false);
const tagInputValue = ref("");

watch(() => props.tags, (newTags) => {
  tags.value = newTags;
}, { immediate: true });

// =================================================================================================================
//  Tag list functionality
// =================================================================================================================

// eslint-disable-next-line
const handleTagRemove = (removedTag) => {
  const filtered_tags = tags.value.filter(tag => tag !== removedTag);
  tags.value = filtered_tags;
};

// eslint-disable-next-line
const showTagInput = () => {
  tagInputVisible.value = true;
  nextTick(() => {
    tagInputRef.value.focus();
  });
};

// eslint-disable-next-line
const handleTagInputConfirm = () => {
  const inputValue = tagInputValue.value;
  let new_tags = tags.value;

  if (inputValue && new_tags.indexOf(inputValue) === -1) {
    new_tags = [...new_tags, inputValue];
  }

  tags.value = new_tags;
  tagInputVisible.value = false;
  tagInputValue.value = "";

  emit('update:tags', tags.value);
};

</script>

<style>

.tag-color-0 {
  color: red;
}
.tag-color-1 {
  color: blue;
}
.tag-color-2 {
  color: orange;
}
.tag-color-3 {
  color: green;
}
.tag-color-4 {
  color: purple;
}

</style>